export const data = {
  banner: {
    heading: `Trusted for hair growth.`,
    headingMen: `Trusted for hair growth.`,
    copy: `Nutrafol Hair Growth Nutraceuticals are officially NSF Contents Certified—adding another layer of assurance with toxicology reviews, ingredient testing, label verification, manufacturing facility inspections, and regular audits.`,
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4f7EJRaxmdxg7ItmeMRGlR/277a848eaeb6c07924e43050525cbef9/nsf-logo.png",
    button: {
      text: "Learn More About Our Standards",
      link: "/standards/",
    },
  },
  badge: {
    heading: `Third-party certified.`,
    image: `https://images.ctfassets.net/0rbfqd9c4jdo/55XmFT3gse0NYT9oN5qIDo/9e3d5cdc0d5946565dac9172e6eb353f/nsf-badge.png`,
  },
}
